import {Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {GameRules} from './rules/game-rules.js';
import {TutorialTextScript} from './tutorial-text-script.js';
//import TutorialPieces from './store-data/Game_Rules_Puzzle_Tut1_Pieces.json';
import {Puzzle} from './puzzle.js';
import {BlobPrefabs} from './blob-prefabs.js';
import {BoardObject} from './board-object.js';
import {FailStateNames} from '../enums/FailStateNames.js';
import {GameFlowController} from './game-flow-controller.js';
import {Statistics} from './statistics.js';
import {StatNames} from '../enums/StatNames.js';
import {CoroutineManager} from '../classes/coroutines/CoroutineManager.js';
import {Coroutine} from '../classes/coroutines/Coroutine.js';
import {DataManager} from '../classes/DataManager.js';
import {TutorialPiecesData} from '../types/Tut1Pieces.js';
export type PrepopulatedPiece = {
    piecePrefab: string;
    row: number;
    column: number;
    specialToInject: string | null;
};

export class TutorialGameRules extends GameRules {
    static TypeName = 'tutorial-game-rules';
    static InheritProperties = true;

    @property.int(0)
    rowCount = 0;
    @property.int(0)
    numberOfTurns = 0;

    @property.float(4)
    gameOverHoldTime = 4;
    // public GameObject beatGameFX;
    // public AudioClip beatGameLoopSFX;
    //private GameObject spawnedFireworks;
    @property.bool(false)
    incrementGameCount = false;
    @property.object({required: true})
    tutorialTextScriptObject!: Object3D;

    pieces: PrepopulatedPiece[] = [];

    private _tutorialScript: TutorialTextScript;
    private _tutorialDone = false;
    private _turnCount = 0;
    private _coroutineManager = new CoroutineManager();

    init() {
        DataManager.instance
            .loadData<TutorialPiecesData>('data/Tut1Pieces.bin')
            .then((data) => {
                this.pieces.push(...data.pieces);
            });
    }

    start(): void {
        this._tutorialScript =
            this.tutorialTextScriptObject.getComponent(TutorialTextScript);
    }
    update(delta: number) {
        this._coroutineManager.update(delta);
    }

    override startNewGame() {
        this._turnCount = 0;
        this._tutorialDone = false;

        this._tutorialScript.startTutorial();

        //increase drop speed cause it's so damn slow
        Puzzle.instance.dropSpeedFactor = Puzzle.instance.dropSpeedFactor * 3;

        for (let x = 0; x < this.rowCount; x++) {
            Puzzle.instance.addRow();
        }

        // spawn pre-populated stacks here
        for (let x = 0; x < this.pieces.length; x++) {
            // 	GameObject pieceObject = Instantiate(pieces[x].piecePrefab, Vector3.zero, Quaternion.identity) as GameObject;
            const pieceObject = BlobPrefabs.instance.spawn(
                this.pieces[x].piecePrefab,
                null,
                false
            );
            const boardObj = pieceObject.getComponent(BoardObject);
            Puzzle.instance.addObject(boardObj, this.pieces[x].row, this.pieces[x].column);
            boardObj.place();
            if (this.pieces[x].specialToInject) {
                // 		GameObject payload = Instantiate(pieces[x].specialToInject, Vector3.zero, pieceObject.transform.rotation) as GameObject;
                const payload = BlobPrefabs.instance.spawn(
                    this.pieces[x].specialToInject,
                    null,
                    false
                );
                boardObj.loadObject(payload);
            }
        }

        super.startNewGame();
    }

    // force end of tutorial
    setTutorialDone() {
        this._tutorialDone = true;
    }

    override detectGameOver() {
        if (this._tutorialDone) {
            this.failStateCause = FailStateNames.TutorialWon;
        }

        return this._tutorialDone;
    }

    override turnComplete() {
        super.turnComplete();
        this._turnCount++;
    }

    override incrementGamesPlayed() {
        if (Statistics.instance.getLong(StatNames.TutorialGamesPlayed) >= 1) {
            Statistics.instance.recordAdditive(StatNames.TutorialGamesPlayed, 1);
        }
    }

    private _gameOverSequenceId = 0;
    private *_gameOverSequence() {
        //yield* waitForSeconds(this.gameOverHoldTime);
        GameFlowController.instance.tutorialPhaseComplete();
    }

    override gameOver(failstate: FailStateNames) {
        // spawnedFireworks = Instantiate(beatGameFX, new Vector3(0,1,0), Quaternion.identity) as GameObject;
        //AudioDirector.instance.PlayLooping(beatGameLoopSFX);
        // StartCoroutine("CleanUpFireworks");

        Puzzle.instance.spawner.gameOver(failstate);
        this.playGameOverSFX();
        this.incrementGamesPlayed();

        this._coroutineManager.stopCoroutine(this._gameOverSequenceId);
        this._gameOverSequenceId = this._coroutineManager.addCoroutine(
            new Coroutine(this._gameOverSequence())
        );
    }

    // IEnumerator CleanUpFireworks()
    // {
    // 	yield return new WaitForSeconds(3.5f);

    // 	float time = Time.time;
    // 	while (time + 1.0f > Time.time)
    // 	{
    // 		float volume = time + 1.0f - Time.time;
    // 		audioDirector.SetLoopingVolume(beatGameLoopSFX, volume);
    // 		yield return null;
    // 	}

    // 	audioDirector.StopLooping(beatGameLoopSFX);

    // 	Destroy(spawnedFireworks);
    // }

    override showHUD() {
        return false;
    }
}
